import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var RenderingMode = /** @class */ (function (_super) {
    __extends(RenderingMode, _super);
    function RenderingMode() {
        var _this = _super.call(this) || this;
        console.warn('[RenderingMode] not implemented');
        return _this;
    }
    RenderingMode.forceNativeConstructor = true;
    RenderingMode.forceNativeMethods = true;
    // JS -> AS Bindings
    RenderingMode.NORMAL = 'normal';
    RenderingMode.CFF = 'cff';
    return RenderingMode;
}(ASObject));
export { RenderingMode };
